import Layout from '@layout/Index'

export const clbTaskTemplate = [
  {
    path: '/clb-task-template',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "clb-task-template-table" */ './pages/ClbTaskTemplateTable.vue'),
        meta: {
          title: '查理宝任务模板列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "clb-task-template-form" */ './pages/ClbTaskTemplateForm.vue'),
        meta: {
          title: '添加查理宝任务模板',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "clb-task-template-form" */ './pages/ClbTaskTemplateForm.vue'),
        meta: {
          title: '编辑查理宝任务模板',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/clb-task-template/clb-task-template.route.js